import addClickHandler from 'mex_components/app/scripts/events/addClickHandler';
import forEachSelector from 'mex_components/app/scripts/elements/forEachSelector';
import getMeta from 'mex_components/app/scripts/storage/getMeta';
import MicroModal from 'micromodal';
import { markButtonsAsEnrolled } from './add_to_cart';

/**
 * Performs a straight enrollment for a course by bypassing the checkout terminal
 *
 * @param {clientId} Uuid of client
 * @param {studentId} Uuid of student
 * @param {itemId} Id of course
 *
*/
export const enrollUser = async (clientId, studentId, itemId) => {
  if(!clientId || !studentId || !itemId) return;

  const fetchUrl = `https://${process.env.API_HOST}/v1/purchases?skip_payment=true`;
  const data = {
    customer_id: clientId,
    customer_type: 'client',
    payment: {},
    items: [
      {
        duration_seconds: 2700,
        item_id: itemId
      }
    ],
    student: {
      id: studentId
    }
  };

  const response = await fetch(fetchUrl, {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });

  if (response.ok) {
    showModal();
  }
};

/**
 * Sends the student's uuid, client uuid and item id
 * to the enrollUser method, which uses this information
 * in the POST request to the purchases endpoint
 *
 * @param {event} Button event
*/
export const handleButtonClick = async (event) => {
  const target = event.target;
  const itemId = target.dataset.offer;
  const clientId = getMeta('student-client-id');
  const studentId = getMeta('student-id');
  
  await enrollUser(clientId, studentId, itemId);

  markButtonsAsEnrolled(itemId);
};

export const showModal = () => {
  MicroModal.show('straight-enrollment-modal',
  {
    disableScroll: true,
    openClass: 'js-micromodal--open',
    onShow: () => {
      document.documentElement.classList.add('html--micromodal-open');
    },
    onClose: (modal, element, event) => {
      event.preventDefault();
      event.stopPropagation();
      document.documentElement.classList.remove('html--micromodal-open');
    }
  });
};

/**
 * Sets up event handlers to handle clicking single-enrollment buttons
*/
const setupEventHandlers = () => {
  forEachSelector('.js-straight-enrollment', (el) => {
    addClickHandler(el, handleButtonClick);
  });
};

export default function setup() {
  setupEventHandlers();
}
